import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updateOperationWindowRule } from '@api/operationWindowRules';

import { TOperationWindowRuleDTO } from '@interfaces/cmModule/dto/operationWindowRulesDTO';
import { IId } from '@interfaces/common/common';
import { IPartialOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { OPERATION_WINDOW_RULES, OPERATION_WINDOW_RULES_EDIT  } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateOperationWindowRulesUpdateReturned {
	isLoadingUpdateOperationWindowRule: boolean;
	updateOperationWindowRule: UseMutateFunction<any, any, IId & TOperationWindowRuleDTO, any>;
}

const useMutateOperationWindowRulesUpdate = ({
	onSuccess,
}: IPartialOnSuccess): IUseMutateOperationWindowRulesUpdateReturned => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutateAsync,
		isLoading,
	} = useMutation<IId & TOperationWindowRuleDTO>({
		mutationKey: [OPERATION_WINDOW_RULES_EDIT],
		mutationFn: updateOperationWindowRule,
		onSuccess: () => {
			onSuccess?.();

			dispatch(setSnackbar({
				message: responseMessages.updateOperationWindowRule,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([OPERATION_WINDOW_RULES]);
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
	});

	return {
		isLoadingUpdateOperationWindowRule: isLoading,
		updateOperationWindowRule: mutateAsync,
	};
};

export default useMutateOperationWindowRulesUpdate;
